import React, { useContext, useState } from 'react';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import history from 'src/history';
import {
  BorderGradient,
  WarningMessageModal,
  Tabs,
  Actions,
  IconWithText,
  Helper,
  Button,
} from 'Components';
import './TemplatesDesktopHeader.css';

const TemplatesDesktopHeader = ({
  tabs,
  tabIndex,
  onTabsChange,
  pageSize,
  onPageSizeChange,
  isTemplateWarningON,
}) => {
  // ! State and Dispatch:
  const { deletionState, dispatch } = useContext(DeletionContext);

  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);
  const translatedTabs = tabs.map((tab) => i18n.t(`templates:${tab}`));
  const handleProceed = () => {
    history.push('/templates/new');
    setOpenWarningMessage(false);
  };
  const handleCancle = () => {
    setOpenWarningMessage(false);
  };
  const handlOnClick = () => {
    if (isTemplateWarningON === 'ON') {
      setOpenWarningMessage(true);
    } else {
      history.push('/templates/new');
    }
  };

  return (
    <div>
      <div className="templates-desktop-header__bar">
        <Helper
          placement="bottom-left"
          text={i18n.t('tutorials:tutorialsTemplatesLanding.6')}
        >
          {/* // ! Buttons container: */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px',
            }}
          >
            <IconWithText
              onClick={handlOnClick}
              text={i18n.t('templates:NewTemplate2')}
              textOrientation="before"
              icon="add_circle"
            />

            {deletionState.isDeletionModeActive ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '10px',
                }}
              >
                <Button
                  className="button button--primary"
                  onClick={() => {
                    dispatch({
                      type: DELETE_ACTIONS.ACTIVATE_DELETE_CONFIRMATION,
                    });
                  }}
                  disabled={!(deletionState.selectedItems.length > 0)}
                >
                  <span>{i18n.t('common:Delete')}</span>
                </Button>
                <Button
                  className="button button--primary"
                  onClick={() =>
                    dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETION_MODE })
                  }
                >
                  <span>{i18n.t('common:Cancel')}</span>
                </Button>
              </div>
            ) : null}
          </div>
          {/* // ! End of buttons container. */}
        </Helper>
      </div>
      <BorderGradient />
      <div className="templates-desktop-header__tabs">
        <Helper text={i18n.t('tutorials:tutorialsTemplatesLanding.1')}>
          <Tabs
            onClick={onTabsChange}
            tabs={translatedTabs}
            index={tabIndex}
            className="tabs__button"
          />
        </Helper>
        <div
          className="templates-desktop-header__results__dropdown"
          style={{ display: deletionState.isDeletionModeActive && 'none' }}
        >
          <Helper
            placement="bottom-left"
            text={i18n.t('tutorials:common.PageSize')}
          >
            <Actions.ResultsPerPage
              value={pageSize}
              onChange={onPageSizeChange}
            />
          </Helper>
        </div>
      </div>
      <div>
        {isWarningMessageOpen && (
          <WarningMessageModal
            onProceed={handleProceed}
            onCancel={handleCancle}
            section="Template"
          />
        )}
      </div>
    </div>
  );
};

TemplatesDesktopHeader.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
  onTabsChange: PropTypes.func,
  pageSize: PropTypes.number,
  onPageSizeChange: PropTypes.func,
  isTemplateWarningON: PropTypes.bool,
};

export default TemplatesDesktopHeader;



// WEBPACK FOOTER //
// ./src/containers/Templates/TemplatesDesktop/TemplatesDesktopHeader/TemplatesDesktopHeader.jsx